













import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, ref } from "@vue/composition-api";
import InformationBoard from "./InformationBoard.vue";
import { detectionState } from "../data/state";
export default Vue.extend({
  components: {
    Modal,
    InformationBoard,
  },

  props: ["modalData"],
  setup() {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "60rem",
      withTopRightCloseBtn: true,
    };

    const is_modal_open = ref(false);
    onMounted(() => {
      detectionState.loadDashboard(true);
      setTimeout(() => {
        is_modal_open.value = true;
      }, 300);
    });

    return {
      config,
      is_modal_open,
    };
  },
});
